import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule, DxTextAreaModule, DxPopupModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { SettingsService } from '../settings.service';
import { MenuItemsByRoleComponent } from './menu-items-by-role.component';
import { MenuItemsByRoleRoutingModule } from './menu-items-by-role-routing.module';
import { ContainerComponent } from 'src/app/components/container/container.component';

@NgModule({
	declarations: [MenuItemsByRoleComponent],
	imports: [
		CommonModule,
		MenuItemsByRoleRoutingModule,
		DxDataGridModule,
		DevEpressCommonModule,
		DxTextAreaModule,
		DxPopupModule,
		ContainerComponent,
	],
	providers: [SettingsService]
})
export class MenuItemsByRoleModule { }
